import { makeAutoObservable, runInAction } from 'mobx';
import { PersonalApi } from './PersonalApi';
import { PersonalProfileDTO } from './PersonalType';

class PersonalModel {
  loading = false;
  error: string | null = null;
  profile: PersonalProfileDTO | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  reset() {
    this.loading = false;
    this.error = null;
    this.profile = null;
  }

  async load() {
    this.loading = true;
    this.error = null;
    try {
      const profile = await PersonalApi.fetchProfile();
      runInAction(() => {
        this.profile = profile;
        if (!profile) {
          this.error = '加载失败';
        }
        this.loading = false;
      });
    } catch {
      runInAction(() => {
        this.error = '加载失败';
        this.loading = false;
      });
    }
  }
}

export const personalModel = new PersonalModel();
